<template>
  <div class="progressBar progress">
    <div :class="`progress-bar progress-bar progress-bar-${bgColor}`" role="progressbar" :style="`width: ${value}%`" :aria-valuenow="value" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  components: {},
  props: {
    value: Number,
    status: String
  },
  mounted () {},
  data: () => ({}),
  computed: {
    bgColor () {
      switch (this.status) {
        case 'error':
          return 'danger'
        case 'in progress':
          return 'info'
        case 'queued':
        case 'created':
          return 'warning'
        case 'completed':
        case 'success':
          return 'success'
      }
      return 'primary'
    }
  }
}
</script>

<style lang="scss">
    @import "./progress-bar";
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar/progress-bar.vue